// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-banner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1.25rem;
  margin: 0 0 1.5rem 0;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 1.4rem;
  line-height: 1.5;
}

.ui-banner__icon {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
}

.ui-banner__text {
  margin: 0;
  font-weight: 500;
}

/* Disposition riche (titre + action) : empilement vertical, action SOUS le message
   (jamais a droite). N'est active que si \`title\` ou \`action\` est fourni -> usages simples inchanges. */
.ui-banner--rich {
  flex-direction: column;
  align-items: stretch;
  gap: 0.7rem;
}
.ui-banner__content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.ui-banner__title {
  font-weight: 700;
  font-size: 1.4rem;
}
.ui-banner__action {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
}

/* Contour (defaut) : bordure fine + texte colore + fond legerement teinte. */
/* info : bordure gris clair, texte gris #595959, fond gris (l'icone porte l'orange + le "i" blanc). */
.ui-banner--info {
  color: #595959;
  border-color: #d7d9d9;
  background: rgba(215, 217, 217, 0.2);
}

.ui-banner--success {
  color: #166534;
  border-color: #16a34a;
  background: #f0fdf4;
}

.ui-banner--danger {
  color: #b91c1c;
  border-color: #dc2626;
  background: #fef2f2;
}

/* warning : orange (action/etat), sans icone. */
.ui-banner--warning {
  color: #c2410c;
  border-color: #fed7aa;
  background: rgba(254, 215, 170, 0.2);
}

/* Fond plein (comme la bande "derniere mise a jour" verte actuelle). */
.ui-banner--filled.ui-banner--info {
  background: #ffedd5;
  border-color: #fed7aa;
  color: #c2410c;
}

.ui-banner--filled.ui-banner--success {
  background: #dcfce7;
  border-color: #bbf7d0;
  color: #166534;
}

.ui-banner--filled.ui-banner--danger {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
}

.ui-banner--filled.ui-banner--warning {
  background: #ffedd5;
  border-color: #fed7aa;
  color: #c2410c;
}
`, "",{"version":3,"sources":["webpack://./src/composants/Banner/Banner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;uGACuG;AACvG;EACE,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,6EAA6E;AAC7E,sGAAsG;AACtG;EACE,cAAc;EACd,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".ui-banner {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.85rem 1.25rem;\n  margin: 0 0 1.5rem 0;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  font-size: 1.4rem;\n  line-height: 1.5;\n}\n\n.ui-banner__icon {\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n}\n\n.ui-banner__text {\n  margin: 0;\n  font-weight: 500;\n}\n\n/* Disposition riche (titre + action) : empilement vertical, action SOUS le message\n   (jamais a droite). N'est active que si `title` ou `action` est fourni -> usages simples inchanges. */\n.ui-banner--rich {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.7rem;\n}\n.ui-banner__content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n.ui-banner__title {\n  font-weight: 700;\n  font-size: 1.4rem;\n}\n.ui-banner__action {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n}\n\n/* Contour (defaut) : bordure fine + texte colore + fond legerement teinte. */\n/* info : bordure gris clair, texte gris #595959, fond gris (l'icone porte l'orange + le \"i\" blanc). */\n.ui-banner--info {\n  color: #595959;\n  border-color: #d7d9d9;\n  background: rgba(215, 217, 217, 0.2);\n}\n\n.ui-banner--success {\n  color: #166534;\n  border-color: #16a34a;\n  background: #f0fdf4;\n}\n\n.ui-banner--danger {\n  color: #b91c1c;\n  border-color: #dc2626;\n  background: #fef2f2;\n}\n\n/* warning : orange (action/etat), sans icone. */\n.ui-banner--warning {\n  color: #c2410c;\n  border-color: #fed7aa;\n  background: rgba(254, 215, 170, 0.2);\n}\n\n/* Fond plein (comme la bande \"derniere mise a jour\" verte actuelle). */\n.ui-banner--filled.ui-banner--info {\n  background: #ffedd5;\n  border-color: #fed7aa;\n  color: #c2410c;\n}\n\n.ui-banner--filled.ui-banner--success {\n  background: #dcfce7;\n  border-color: #bbf7d0;\n  color: #166534;\n}\n\n.ui-banner--filled.ui-banner--danger {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.ui-banner--filled.ui-banner--warning {\n  background: #ffedd5;\n  border-color: #fed7aa;\n  color: #c2410c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
